import '../css/slider.css';

import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

(function (Drupal, once) {
  Drupal.behaviors.heroSwiper = {
    attach(context) {
      once('hero-swiper', '.slider--hero', context).forEach((el) => {
        new Swiper(el, {
          modules: [Autoplay, Pagination, EffectFade],

          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },

          slidesPerView: 1,
          loop: true,
          speed: 3200,

          autoplay: {
            delay: 8000,
            disableOnInteraction: false,
          },

          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
        });
      });
    },
  };
})(Drupal, once);

